import React, {Component} from "react";
import PropTypes from "prop-types";
import {arrayMove} from "react-sortable-hoc";
import SortableCoursesList from './SortableCoursesList';
import SortableRulesContainer from './SortableRulesContainer';

class SortableRules extends Component {
    state = {
        conditions: [...this.props.conditions]
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        let {conditions} = this.state;
        conditions = arrayMove(this.state.conditions, oldIndex, newIndex);
        this.setState({conditions});

    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {
        if (this.state.conditions != nextProps.conditions) {
            this.setState({conditions: nextProps.conditions});
        }
    };

    render() {
        return (
            <SortableRulesContainer
                addCondition={this.props.addCondition}
                removeRule={this.props.removeRule}
                removeCondition={this.props.removeCondition}
                setConditionOperator={this.props.setConditionOperator}
                setConditionValue={this.props.setConditionValue}
                setConditionConnector={this.props.setConditionConnector}
                setConditionResult={this.props.setConditionResult}
                updateConditionSubject={this.props.updateConditionSubject}
                renderSubjectSelect={this.props.renderSubjectSelect}
                onSortEnd={this.props.onSortEnd}
                items={this.state.conditions}


            />
        );
    }
}

export default SortableRules;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableRules.js